import { GsFormSchema } from 'libs/shared/src/components';
import { BASIC_SCHEMA_FIELDS } from '../basics';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the leaflet-detail component form.
 * Defines the fields to display for the form.
 */
export const LEAFLET_DETAIL_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [...BASIC_SCHEMA_FIELDS, ...SPACING_SCHEMA]
};
